import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { DeviceListMaintenanceDto } from './DeviceListMaintenanceDto';
import { DeviceItemMaintenanceDto } from './DeviceItemMaintenanceDto';
import { BaseMaintenanceController } from '../_base/BaseMaintenanceController';

@Injectable()
export class DeviceMaintenanceController extends BaseMaintenanceController<DeviceListMaintenanceDto, DeviceItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "device");
    }

    public getResourceRoot(): string {
        return "DEVICE";
    }

    public buildUrl(uri: string): string {
        return "/system/dataandparameters/device" + uri;
    }
} 